import React from 'react';
import { Icon } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { IconType } from './models';

interface IProps {
    first?: boolean;
    icon: IconType;
    disabled?: boolean;
    onClick?: () => void;
}

export default function ActionButton({ first = false, icon, disabled = false, onClick }: IProps) {
    return (
        <IconButton
            style={{
                backgroundColor: '#EFEFEF',
                marginLeft: first ? undefined : 6,
                outline: 'none',
                height: '40px',
                width: '40px',
            }}
            disabled={disabled}
            onClick={onClick}
        >
            <Icon component={icon} color={'primary'} />
        </IconButton>
    );
}
